export const APP_MOUNT_SELECTOR = '#app';
export const APP_ENV = 'APP_ENV';

export enum ROUTE_PERMISSIONS {
  FOR_ALL = 'for_all',
  FOR_LOGGED_IN = 'for_logged_in',
  FOR_LOGGED_OUT = 'for_logged_out',
}
